
export const permission = {
    add: "You don't have permission to add record.",
    edit: "You don't have permission to edit record.",
    delete: "You don't have permission to delete record.",
    save: "You don't have permission to save record.",
    approve: "You don't have permission to approve record.",
}